import React from "react";
import { useGetCompletedCoursesQuery } from "../../../redux-toolkit/features/my-activity/myActivityApiSlice";
import downloadIcon from "../../../assets/Icons/download.svg";
import goldStarIcon from "../../../assets/myactivity2/task_badges/gold_star_icon.svg";
import goldTimerIcon from "../../../assets/myactivity2/task_badges/gold_timer_icon.svg";
import { CertificatePDF } from "../../MyActivity/CertificatePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import "./CoursesJourney.css";

const CourseCard = ({ course }) => {
  return (
    <div className="course-card">
      <div className="course-image-container">
        <img
          src={
            course?.course?.coverImage ||
            "https://via.placeholder.com/300x200?text=Course"
          }
          alt="course-cover"
          className="course-image"
        />
        <PDFDownloadLink
          document={
            <CertificatePDF
              name={`${course?.user?.fname || "User"} ${
                course?.user?.lname || "Name"
              }`}
              courseName={course?.course?.name || "Course"}
            />
          }
          fileName={`${course?.course?.name || "Course"}_certificate.pdf`}
        >
          {({ loading }) => (
            <button disabled={loading} className="download-btn">
              <img
                src={downloadIcon}
                alt="download"
                className="download-icon"
              />
            </button>
          )}
        </PDFDownloadLink>
      </div>

      <div className="course-content">
        <h3 className="course-title">
          {course?.course?.name || "Course Title"}
        </h3>
        <p className="course-description">
          {course?.course?.description ||
            "At vero eos et accusamus et iusto odio dignissimos"}
        </p>

        <div className="course-metrics">
          <div className="metric">
            <img src={goldStarIcon} alt="star" className="metric-icon" />
            <span className="metric-text">20 Points</span>
          </div>
          <div className="metric">
            <img src={goldTimerIcon} alt="timer" className="metric-icon" />
            <span className="metric-text">2.20 hours</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CoursesJourney = ({ currentProgress }) => {
  const { data, isLoading, error } = useGetCompletedCoursesQuery();

  // Show loading state if courses are still loading
  if (isLoading) {
    return (
      <div className="courses-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading your completed courses...</p>
        </div>
      </div>
    );
  }

  // Show error state if there's an error
  if (error) {
    return (
      <div className="courses-container">
        <div className="error-state">
          <p>Error loading courses. Please try again later.</p>
        </div>
      </div>
    );
  }

  const completedCourses = data?.data || [];

  return (
    <div className="courses-container">
      {completedCourses.length === 0 ? (
        <div className="no-courses">
          <p>
            No completed courses yet. Start learning to earn your first
            certificate!
          </p>
        </div>
      ) : (
        <div className="courses-grid">
          {completedCourses.map((course, index) => (
            <CourseCard key={course._id || index} course={course} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoursesJourney;
